import React from "react";
import { RouterProvider } from "react-router-dom";
import routers from "./routers";

export default function App() {
  return <RouterProvider router={routers} />;
}
